export default "__VITE_ASSET__faeab618__"